module.exports = __webpack_public_path__ + "img/img_index_letter_xkt@2x.a7e996f5.png";